import * as React from 'react';
import { useState, useEffect } from 'react';
import { useFilterSelectionStore } from 'src/hooks/component/filter_selection';
import { FilterSelection } from 'src/reusable/global';
import System from 'src/helper/system';
import { useAlertStore } from 'src/hooks/Alert';

const StockAlertSearchBox = (props) => {
    const keyToSearchType = {
        customerPartNumber:'Customer Part Number',
        manufacturerPartNumber:'Manufacturer Part Number',
        manufacturerName:'Manufacturer',
    }
    const [searchKey, setSearchKey] = useState('manufacturerPartNumber');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [searchKeywordError, setSearchKeywordError] = useState('');
    const [searchTermError, setSearchTermError] = useState('');
    const [{ filter_list }, { }, { set_filter_list }] = useFilterSelectionStore();
    const [{ }, { get_stock_manufacturers }, { }] = useAlertStore();
    const [manufecturers, setManufecturers] = useState([])

    const setSearch = async (event) => {
        setSearchKey(event.target.value);
        setSearchKeyword('');
        setSearchTermError('');
        setSearchKeywordError('');
    };

    useEffect(() => {
        async function fetchManufacturerList() {
            let res= await get_stock_manufacturers()
            setManufecturers(res?.manufacturers || [])
        }
        fetchManufacturerList();
    }, [])

    useEffect(() => {
        if (filter_list && filter_list.length <= 0) {
            setSearchKey('manufacturerPartNumber')
            setSearchKeyword('')
        }
    }, [filter_list])

    const onSearch = () => {
        // Validate Search Keyword
        if (!validateSearchKeyword()) {
            return false;
        }
        set_filter_list([{
            key: searchKey,
            searchType: keyToSearchType[searchKey],
            searchKeyword: searchKeyword?.trim()
        }]);
    }
    const validateSearchKeyword = () => {
        if(!searchKey?.trim()){
            setSearchTermError("Please enter search term")
            setSearchKeywordError('');
            return false;
        }
        setSearchTermError('');
        if (!searchKeyword?.trim()) {
            setSearchKeywordError('Search Alerts is required')
            return false;
        }
        if (searchKeyword?.trim().length < 3) {
            setSearchKeywordError('Search Alert length must be 3 char or more')
            return false;
        }
        setSearchKeywordError('');
        return true;
    }
    return (
        <>
            <div className="search-section mb-3 dashboard-hide">
                <div className="bs5 row mx-0">
                    <div className="col-xl-8 col-lg-8 col-sm-11 px-0">
                        <div className="bs5 row g-2">
                            <div className="col-auto ps-sm-2 pe-sm-0">
                                <div className="form-group mb-1">
                                    <label htmlFor="search"><b>Search</b></label>
                                    <div className="selectbox">
                                        <select className="form-control form-control-sm" id='Search'
                                            onChange={setSearch} value={searchKey}>
                                            <option value="">Select</option>
                                            {Object.entries(keyToSearchType).map(([key, value]) => {
                                                return <option key={key} value={key}>{value}</option>
                                            })}
                                        </select>
                                    </div>
                                    {searchTermError && <p className='error my-0'>{searchTermError}</p>}
                                </div>
                            </div>
                            <div className="col-sm-5 ps-sm-2 pe-sm-0">
                                <div className="form-group mb-1">
                                    <label htmlFor="email"
                                        className="d-none d-sm-inline-block">&nbsp;</label>
                                    <div className="input-group bs5 flex-nowrap">
                                        {searchKey === "manufacturerName" ?
                                            <div className="selectbox">
                                            <select className="form-control form-control-sm"
                                                onChange={(event)=>{
                                                    setSearchKeyword(event.target.value);
                                                }} value={searchKeyword}>
                                                     <option value="">select</option>
                                               {manufecturers.map((option,index)=> <option key={index} value={option}>{option}</option>)}
                                            </select>
                                        </div>
                                            : <input type="text" className="form-control form-control-sm"
                                                placeholder="Search Alerts" value={searchKeyword} onChange={(event)=>{
                                                    setSearchKeyword(event.target.value);
                                                }}
                                                onKeyDown={(e) => System.onEnterKeyPress(e) && onSearch()} />}
                                        <div className="bs5 input-group-append flex-nowrap rounded-1">
                                            <a className="bs5 btn btn-secondary btn-search-icon"
                                                onClick={() => onSearch()}><i className="fa fa-search text-black-stone"></i></a>
                                        </div>
                                    </div>
                                </div>
                                {searchKeywordError && <p className='error my-0'>{searchKeywordError}</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <FilterSelection />
        </>
    );
}

export default StockAlertSearchBox;